window.googleTagManagerService = (function () {
    const settings = {
        gtm: false,
        ga4: false,
        gtmDebug: false,
        ga4Debug: false,
        queues: [],
        loaded: false,
        data: {}
    }

    let processingQueue = false;
    const queue = [];

    const currencyCode = 'USD';

    function onClassChange(node, callback) {
        let lastClassString = node.classList.toString();

        const mutationObserver = new MutationObserver((mutationList) => {
            for (const item of mutationList) {
                if (item.attributeName === "class") {
                    const classString = node.classList.toString();
                    if (classString !== lastClassString) {
                        callback(mutationObserver);
                        lastClassString = classString;
                        break;
                    }
                }
            }
        });

        mutationObserver.observe(node, { attributes: true });

        return mutationObserver;
    }

    const isDebugMode = function(context) {
        return settings[context+'Debug'] === true;
    }

    const event = function (context, data) {
        // Process queues
        processQueues();

        if (isDebugMode(context)) {
            console.log('[DEBUG] '+context, data);
        } else {
            if (window.dataLayer) {
                // console.log('[DEBUG] '+context + ' window.dataLayer.push', data);
                window.dataLayer.push(data);
            }
        }
    }
    
    const eventGtm = function (data) {
        event('gtm', data);
    }
    
    const eventGa4 = function (data) {
        event('ga4', data);
    }

    const processQueues = function () {
        if (processingQueue) {
            return;
        }

        processingQueue = true;
        try {
            while (queue.length) {
                const closure = queue.shift();
                closure();
            }
        } finally {
            processingQueue = false;
        }

        return this;
    }

    const clearEventsGtm = function(){
        if (isDebugMode('gtm')) {
            return;
        }

        const array = window.dataLayer;
        const eventsToRemove= ["addToCart", "viewProduct"];

        for (let i=0; i < array.length; i++) {
            if (eventsToRemove.indexOf(array[i].event) !== -1) {
                array[i] = {};
            }
        }
    }

    const getCartTotal = function() {
        const cart = data.get('cart');
        return cart && cart.value ? parseFloat(cart.value) : 0.0;
    }

    const data = {
        set: (id, value) => {
            settings.data[id] = value;
        },
        get: (id) => {
            return settings.data[id] ?? null;
        },
    };

    const normaliseItem = function(item) {
        for (const key in item) {
            if (item.hasOwnProperty(key)) {
                item[key] = item[key] || undefined;
            }
        }

        return item;
    }

    const self = {
        init: function (args) {
            if (!settings.loaded) {
                settings.gtm = args.gtm || false;
                settings.gtmDebug = args.gtmDebug || false;
                settings.ga4 = args.ga4 || false;
                settings.ga4Debug = args.ga4Debug || false;
            }

            settings.loaded = true;

            // Process queues
            setTimeout(() => {
                processQueues();
            }, 1500);

            return self;
        },
        queue: function(closure) {
            if (typeof closure === "function") {
                queue.push(closure);
            }
        },
        newsletter: function (label) {
            // console.log(['newsletter', label]);
            if (settings.gtm) {
                eventGtm( {
                    event: 'interaction',
                    eventCategory: 'newsletter',
                    eventAction: 'signup',
                    eventLabel: label
                });
            }
            if (settings.ga4) {
                if (label === 'signup-submit') {
                    eventGa4({
                        event: 'newsletter_subscribe'
                    });
                }
            }

            return self;
        },
        pageView: function (pageType, userId) {
            if (settings.ga4) {
                eventGa4({
                    event: 'page_view',
                    page_type: pageType,
                    user_id : userId || undefined,
                    login_status : userId ? 'login' : 'logout'
                })
            }

            return self;
        },
        viewCollection: function(items) {
            if (settings.ga4) {
                eventGa4({
                    ecommerce: null
                });
                eventGa4({
                    event: 'view_item_list',
                    ecommerce: {
                        'currency': currencyCode,
                        'items': items.map((item) => normaliseItem(item)),
                    }
                });
            }
        },
        selectProduct: function(item, callback) {
            if (settings.gtm) {
                clearEventsGtm();
                eventGtm({
                    event: 'viewProduct',
                    eventCategory: 'products',
                    eventAction: 'view-product',
                    eventLabel: item.name.replace(/ /g,"-"),
                    ecommerce: {
                        currencyCode: currencyCode,
                        add: {
                            products: [{
                                name: item.name,
                                id: item.id
                            }]
                        }
                    }
                });
            }
            if (settings.ga4) {
                eventGa4({ecommerce: null});
                eventGa4({
                    event: 'select_item',
                    ecommerce: {
                        currency: currencyCode,
                        items: [{
                            item_id: item.id,
                            item_name: item.name,
                            index: item.index,
                            item_category: item.category || undefined,
                            item_list_id: item.list_id,
                            item_list_name: item.list_name
                        }]
                    }
                });
            }

            if (typeof callback === 'function') {
                callback();
            }

            return self;
        },
        viewProductGTM: function (eventLabel, productId, productTitle) {
            if (settings.gtm) {
                window.dataLayer.push({
                    'event': 'viewProduct',
                    'eventCategory': 'ab-test',
                    'eventAction': 'view-product',
                    'eventLabel': eventLabel,
                    'ecommerce': {
                        'currencyCode': currencyCode,
                        'add': {
                            'products': [{
                                'name': productTitle,
                                'id': productId
                            }]
                        }
                    }
                });

            }

        },
        viewProduct: function (eventLabel, item) {
            if (settings.ga4) {
                eventGa4({ecommerce: null});
                eventGa4({
                    event: 'view_item',
                    ecommerce: {
                        currency: currencyCode,
                        items: [
                            normaliseItem(item)
                        ]
                    }
                });
            }

            return self;
        },
        login: function() {
            if (settings.ga4) {
                eventGa4({
                   event: 'login'
                });
            }
        },
        signUp: function() {
            if (settings.ga4) {
                eventGa4({
                   event: 'sign_up'
                });
            }
        },
        addToCart: function(item) {
            if (settings.ga4) {
                if (item) {
                    const quantity = parseInt(item.quantity);
                    const price = parseFloat(item.price) / 100;
                    const value = price * quantity;

                    eventGa4({ ecommerce: null });
                    eventGa4({
                        'event': 'add_to_cart',
                        'ecommerce': {
                            currency: currencyCode,
                            value: value,
                            items: [{
                                item_id: item.product_id + "",
                                item_name: item.product_title,
                                item_category: item.product_type || undefined,
                                item_variant: item.variant_id,
                                price: price,
                                quantity: quantity
                            }]
                        }
                    })
                }
            }
        },
        viewCart: function() {
            if (settings.ga4) {
                const cart = data.get('cart');
                if (cart) {
                    eventGa4({ecommerce: null});
                    eventGa4({
                        'event': 'view_cart',
                        'ecommerce': {
                            currency: currencyCode,
                            value: cart.value,
                            items: cart.items
                        }
                    });
                }
            }
        },
        removeFromCartByItem: function(item, quantity) {
            if (settings.ga4) {
                if (item) {
                    quantity = parseInt(quantity);

                    eventGa4({ecommerce: null});
                    eventGa4({
                        event: 'remove_from_cart',
                        ecommerce: {
                            currency: currencyCode,
                            value: parseFloat(item.price) * quantity,
                            items: [{
                                item_name: item.item_name,
                                item_id: item.item_id,
                                item_category: item.item_category || undefined,
                                item_variant: item.item_variant,
                                price: parseFloat(item.price),
                                quantity: quantity
                            }]
                        }
                    });
                }
            }
        },
        removeFromCartByVariantId: function(variantId, quantity) {
            if (settings.ga4) {
                const cart = data.get('cart');
                if (cart) {
                    // Find item by variant
                    variantId = variantId && variantId.replace(/^updates_/i, '') || '';
                    const item = (cart.items || []).find(function (item) {
                        return item.item_variant + "" === variantId;
                    });

                    this.removeFromCartByItem(item, quantity);
                }
            }
        },
        removeFromCartByLineId: function(lineId, quantity) {
            if (settings.ga4) {
                const cart = data.get('cart');
                if (cart) {
                    lineId = parseInt(lineId);
                    if (lineId) {
                        this.removeFromCartByItem(cart.items[lineId - 1], quantity);
                    }
                }
            }
        },
        addOrRemoveFromCartByLineId: function(lineId, quantity) {
            if (settings.ga4) {
                const cart = data.get('cart');
                if (cart) {
                    lineId = parseInt(lineId);
                    const item = cart.items[lineId - 1];
                    if (item) {
                        if (quantity === 0) {
                            self.removeFromCartByItem(item, item.quantity);
                        }  else {
                            item.quantity = quantity;
                            self.addToCart(item);
                        }
                    }
                }
            }
        },
        observeClassChange: (node, callback) => {
            if (!node || typeof callback !== 'function') {
                return
            }

            onClassChange(node, (observer) => {
                callback(node.classList);
            });
        },
        cartData: (cart) => {
            if (!cart) {
                return;
            }
            data.set('cart', {
                value: (cart.total_price / 100),
                items: cart.items.map((item) => {
                    return {
                        item_id: item.product_id + "",
                        item_name: item.product_title,
                        item_variant: item.variant_id + "",
                        item_category: item.product_type || undefined,
                        price: (item.price / 100),
                        quantity: item.quantity,
                    }
                })
            })
        },
        synCart: () => {
            fetch('/cart.js', {
                headers: {'Content-Type': 'application/json', 'Accept': `application/json`}
            })
                .then((response) => {
                    return response.json();
                })
                .then((state) => {
                    self.cartData(state);
                });
        }
    }

    return self;
})();

document.addEventListener("DOMContentLoaded", function () {
    // Autoload once Google Tag Manager
    if (window.googleTagManagerService) {
        window.googleTagManagerService.init({
            gtm: true,
            ga4: true,
            gtmDebug: false,
            ga4Debug: false
        });
    }
});
